if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){
    
    // Home arrow scroll
    $('.arrow-home').click(function(event) {
        $('body, html').animate({
            scrollTop: $('.hero').outerHeight()
        });
    });
     

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


    // SLIDERS
    $('.sym-slides').slick({
        accessibility: false
    });
    // slider hero home
	$('.hero-slides').slick({
        accessibility: false,
		fade:true,
		autoplay :true,
		autoplaySpeed:5000,
		speed:500,
		pauseOnFocus:false,
		pauseOnHover :false,
        arrows:false,
        dots: false,
        asNavFor: '.hero__dots',
		responsive: [
			{
			  breakpoint: 1001,
			  settings: {
					arrows:false,
                    dots: true,
			  }
			}
		]
    });
    $('.hero__dots').slick({
        slidesToShow: 3,
        slidesToScroll: 3,
        asNavFor: '.hero-slides',
        dots: false,
        // centerMode: true,
        focusOnSelect: true,
        infinite: false,
        centerPadding: '60px',
        arrows: false,
        fade: false,
        centerMode: false,
        accessibility: false,
    });
    // slider bg content
    $('.slider-bg-content').slick({
        arrows: true,
        dots: false,
        infinite: true,
        autoplay: false,
        autoplaySpeed: 4000,
        speed: 700,
        fade: true,
        accessibility: true,
        responsive: [
            {
                breakpoint: 600,
                settings: {
                    adaptiveHeight: true,
                }
            }
        ]
    });
    
    // slider bg content
    $('.sym-slides-reviews').slick({
        dots: true,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 4000,
        speed: 300,
        accessibility: true,
        arrows: true,
    });
    // slider Gallery 
    $('.gallery-slides').slick({
        autoplay: true,
        autoplaySpeed: 2000,
        arrows: true,
        infinite: true,
        accessibility: true,
        fade: true,
        speed: 1000,
        responsive: [
            {
              breakpoint: 701,
              settings: {
                fade: false,
                slidesToScroll: 1,
                centerMode: true,
                centerPadding: '60px',
                slidesToShow: 2,
              }
            },
            {
              breakpoint: 600,
              settings: {
                fade: false,
                slidesToScroll: 1,
                centerMode: true,
                centerPadding: '60px',
                slidesToShow: 1,
              }
            },
        ]
    });

    //Loading preload
    if( document.getElementById("home") && document.getElementById("preloader-home")){
        document.onreadystatechange = function () { 
            if (document.readyState === "complete") {

                setTimeout(function(){
                    document.documentElement.scrollTop = 0;
                    document.getElementById("preloader-home").classList.add("hide");
                    document.getElementById("preloader-overlay").classList.add("hide");
                    document.getElementById("bottom-content").classList.add("hide");
                },1000);
            }
        };
    }
})();

/** ADA Tab Links Functionality for Keyboard Navigation in Menu **/

function updateMenuTabIndex() {
    const menu = document.querySelector('#header');
    const isMenuVisible = menu && menu.classList.contains('open-menu');
    const elements = document.querySelectorAll('.privary-navigation__item a');
    
    elements.forEach(element => {
        element.setAttribute('tabindex', isMenuVisible ? '0' : '-1');
    });
}

document.addEventListener('DOMContentLoaded', () => {
    updateMenuTabIndex();

    document.addEventListener('focusin', updateMenuTabIndex);
    const menu = document.querySelector('#header');
    if (menu) {
        menu.addEventListener('transitionend', updateMenuTabIndex);
    }
});